module.exports = __webpack_public_path__ + "img/eLearning_content_img_01.51440cd7.jpg";